import _ from 'lodash'

export const NODE_ID = '$treeNodeId'

let seed = 0

/**
 * 为每条数据注入一个NodeId
 * @param data Array
 */
export function injectNodeId(data) {
  _.each(data, (item) => {
    if (_.isNil(item[NODE_ID])) {
      Object.defineProperty(item, NODE_ID, {
        value: seed++,
        enumerable: false,
        configurable: false,
        writable: false,
      })
    }
    if (item.children) {
      injectNodeId(item.children)
    }
  })
}
